(function () {
    const headers = document.querySelectorAll('.sidebar__item-header');

    headers.forEach(header => {
        header.addEventListener('click', function () {
            const currentItem = header.parentElement;
            const currentSublist = currentItem.querySelector('.sidebar__sub-list');
            const currentArrow = header.querySelector('.sidebar__item-arrow');
            
            // Close all other open sublists and reset arrows
            document.querySelectorAll('.sidebar__sub-list').forEach(sublist => {
                if (sublist !== currentSublist) {
                    sublist.classList.remove('show');
                }
            });

            document.querySelectorAll('.sidebar__item-arrow').forEach(arrow => {
                if (arrow !== currentArrow) {
                    arrow.classList.remove('down');
                }
            });

            // Toggle the selected sublist and arrow
            currentSublist.classList.toggle('show');
            currentArrow.classList.toggle('down');
        });
    });
})();


(function() {
    var navBar = document.getElementById("navbar")
  "use strict";
  function toggleHandler(toggle) {
    toggle.addEventListener( "click", function(e) {
    e.preventDefault();
    if(this.classList.contains("active")) {
        this.classList.remove("active");
        navBar.style.display = "none";
    }
    else{
        this.classList.add("active");
        navBar.style.display = "flex";
    }
    });
  }
    toggleHandler(document.querySelector(".burger"))
})();